import {
  WindTaxonomy,
  TaxonomyCustomerAdmin,
  TaxonomyCountryCustomer,
  TaxonomyCustomerBrand,
  TaxonomyOperations,
  TaxonomyAssetInfoAdmin,
  TaxonomyAssetManufacturer,
  TaxonomySystemInfoAdminCompleted,
  TaxonomySystemInfoAdmin,
  TaxonomyBearingInfoAdmin,
  ModifyAsset,
  IassetKeyUpdate,
  TaxonomyAssetNameBearings,
  ITaxonomyUpload,
} from './types';

export enum TaxonomyActionTypeNames {
  FETCH_ALL_SUCCESS = '@@taxonomy/FETCH_ALL_SUCCESS',
  FETCH_ALL_ERROR = '@@taxonomy/FETCH_ALL_ERROR',

  FETCH_INDUSTRY_TAXONOMY_CUSTOMER_SUCCES = '@@taxonomy/INDUSTRY_TAXONOMY_CUSTOMER_SUCCES',
  FETCH_INDUSTRY_TAXONOMY_CUSTOMER_ERROR = '@@taxonomy/INDUSTRY_TAXONOMY_CUSTOMER_ERROR',
  FETCH_INDUSTRY_TAXONOMY_CUSTOMER_POST_SUCCESS = '@@taxonomy/INDUSTRY_TAXONOMY_POST_SUCCESS',

  FETCH_BRAND_TAXONOMY_CUSTOMER_SUCCES = '@@taxonomy/INDUSTRY_BRAND_CUSTOMER_SUCCES',
  FETCH_BRAND_TAXONOMY_CUSTOMER_ERROR = '@@taxonomy/INDUSTRY_BRAND_CUSTOMER_ERROR',

  DELETE_WINDFARM_SUCCESS = '@@taxonomy/DELETE_WINDFARM_SUCCESS',
  DELETE_WINDFARM_ERROR = '@@taxonomy/DELETE_WINDFARM_ERROR',

  DELETE_TURBINE_SUCCESS = '@@taxonomy/DELETE_TURBINE_SUCCESS',
  DELETE_TURBINE_BY_ID_SUCCESS = '@@taxonomy/DELETE_TURBINE_BY_ID_SUCCESS',
  DELETE_TURBINE_ERROR = '@@taxonomy/DELETE_TURBINE_ERROR',

  ADD_TAXONOMY_SUCCESS = '@@taxonomy/ADD_TAXONOMY_SUCCESS',
  ADD_TAXONOMY_ERROR = '@@taxonomy/ADD_TAXONOMY_ERROR',

  UPDATE_TAXONOMY_SUCCESS = '@@taxonomy/UPDATE_TAXONOMY_SUCCESS',

  MODIFY_WINDFARM_SUCCESS = '@@taxonomy/MODIFY_WINDFARM_SUCCESS',
  MODIFY_WINDFARM_ERROR = '@@taxonomy/MODIFY_WINDFARM_ERROR',

  GET_COUNTRIES_SUCCESS = '@@taxonomy/GET_COUNTRIES_SUCCESS',
  GET_COUNTRIES_ERROR = '@@taxonomy/GET_COUNTRIES_ERROR',

  GET_OPERATIONS_SUCCESS = '@@taxonomy/GET_OPERATIONS_SUCCESS',
  GET_OPERATIONS_ERROR = '@@taxonomy/GET_OPERATIONS_ERROR',

  FETCH_ASSETS_SUCCESS = '@@taxonomy/FETCH_ASSETS_SUCCESS',
  FETCH_ASSETS_ERROR = '@@taxonomy/FETCH_ASSETS_ERROR',

  GET_ASSETS_MANUFACTURER_MODELS_SUCCESS = '@@taxonomy/GET_ASSETS_MANUFACTURER_MODELS_SUCCESS',
  GET_ASSETS_MANUFACTURER_MODELS_ERROR = '@@taxonomy/GET_ASSETS_MANUFACTURER_MODELS_ERROR',

  POST_NEW_ASSET_SUCCESS = '@@taxonomy/POST_NEW_ASSET_SUCCESS',
  POST_NEW_ASSET_ERROR = '@@taxonomy/POST_NEW_ASSET_ERROR',

  PUT_NEW_ASSET_SUCCESS = '@@taxonomy/PUT_NEW_ASSET_SUCCESS',

  PUT_ASSET_SUCCESS = '@@taxonomy/PUT_ASSET_SUCCESS',
  PUT_ASSET_ERROR = '@@taxonomy/PUT_ASSET_ERROR',

  DELETE_ASSET_SUCCESS = '@@taxonomy/DELETE_ASSET_SUCCESS',

  GET_BEARING_POSITIONS_SUCCESS = '@@taxonomy/GET_BEARING_POSITIONS_SUCCESS',
  GET_BEARING_POSITIONS_ERROR = '@@taxonomy/GET_BEARING_POSITIONS_ERROR',
  GET_BEARING_SUCCESS = '@@taxonomy/GET_BEARING_SUCCESS',

  POST_BEARINGS_SUCCESS = '@@taxonomy/POST_BEARINGS_SUCCESS',
  POST_BEARINGS_ERROR = '@@taxonomy/POST_BEARINGS_ERROR',

  PUT_BEARINGS_SUCCESS = '@@taxonomy/PUT_BEARINGS_SUCCESS',
  PUT_BEARINGS_ERROR = '@@taxonomy/PUT_BEARINGS_ERROR',

  DELETE_BEARING_SUCCESS = '@@taxonomy/DELETE_BEARING_SUCCESS',

  PUT_TURBINE_SUCCESS = '@@taxonomy/PUT_TURBINE_SUCCESS',

  GET_UPLOAD_TAXONOMY_SUCCESS = '@@taxonomy/GET_UPLOAD_TAXONOMY_SUCCESS',
  GET_UPLOAD_TAXONOMY_ERROR = '@@taxonomy/GET_UPLOAD_TAXONOMY_ERROR',
}

interface IGetTaxonomySuccess {
  type: typeof TaxonomyActionTypeNames.FETCH_ALL_SUCCESS;
  taxonomy: WindTaxonomy[];
}

interface IGetTaxonomyError {
  type: typeof TaxonomyActionTypeNames.FETCH_ALL_ERROR;
  fetchStatus: string;
}

interface IDeleteWindFarmSuccess {
  type: typeof TaxonomyActionTypeNames.DELETE_WINDFARM_SUCCESS;
  taxonomy: WindTaxonomy[];
}

interface IDeleteWindFarmByIdSuccess {
  type: typeof TaxonomyActionTypeNames.DELETE_TURBINE_BY_ID_SUCCESS;
  sectionSystemKey: string;
}

interface IDeleteTurbineError {
  type: typeof TaxonomyActionTypeNames.DELETE_TURBINE_ERROR;
  fetchStatus: string;
}

interface IDeleteTurbineSuccess {
  type: typeof TaxonomyActionTypeNames.DELETE_TURBINE_SUCCESS;
  taxonomy: WindTaxonomy[];
}

interface IDeleteWindFarmError {
  type: typeof TaxonomyActionTypeNames.DELETE_WINDFARM_ERROR;
  fetchStatus: string;
}

interface IGetIndustryTaxonomyCustomerSuccess {
  type: typeof TaxonomyActionTypeNames.FETCH_INDUSTRY_TAXONOMY_CUSTOMER_SUCCES;
  taxonomyCustomer: TaxonomyCustomerAdmin[];
}
interface IGetIndustryTaxonomyCustomerError {
  type: typeof TaxonomyActionTypeNames.FETCH_INDUSTRY_TAXONOMY_CUSTOMER_ERROR;
  fetchStatus: string;
}
interface IGetIndustryTaxonomyCustomerPostSuccess {
  type: typeof TaxonomyActionTypeNames.FETCH_INDUSTRY_TAXONOMY_CUSTOMER_POST_SUCCESS;
  fetchStatus: string;
  taxonomy: TaxonomySystemInfoAdminCompleted[];
}

interface IGetBrandTaxonomyCustomerSuccess {
  type: typeof TaxonomyActionTypeNames.FETCH_BRAND_TAXONOMY_CUSTOMER_SUCCES;
  taxonomyBrand: TaxonomyCustomerBrand[];
}
interface IGetBrandTaxonomyCustomerError {
  type: typeof TaxonomyActionTypeNames.FETCH_BRAND_TAXONOMY_CUSTOMER_ERROR;
  fetchStatus: string;
}

interface IPostTaxonomyCustomerSuccess {
  type: typeof TaxonomyActionTypeNames.ADD_TAXONOMY_SUCCESS;
  taxonomyCustomer: TaxonomyCustomerAdmin[];
}
interface IPostTaxonomyCustomerError {
  type: typeof TaxonomyActionTypeNames.ADD_TAXONOMY_ERROR;
  fetchStatus: string;
}

interface IPutTaxonomyCustomerSuccess {
  type: typeof TaxonomyActionTypeNames.UPDATE_TAXONOMY_SUCCESS;
  taxonomyCustomer: TaxonomyCustomerAdmin[];
}

interface IGetCountriesSuccess {
  type: typeof TaxonomyActionTypeNames.GET_COUNTRIES_SUCCESS;
  taxonomyCountryCustomer: TaxonomyCountryCustomer[];
}
interface IGetCountriesError {
  type: typeof TaxonomyActionTypeNames.GET_COUNTRIES_ERROR;
  fetchStatus: string;
}

interface IModifyTaxonomyCustomerSuccess {
  type: typeof TaxonomyActionTypeNames.MODIFY_WINDFARM_SUCCESS;
  taxonomyCustomer: TaxonomyCustomerAdmin[];
}
interface IModifyTaxonomyCustomerError {
  type: typeof TaxonomyActionTypeNames.MODIFY_WINDFARM_ERROR;
  fetchStatus: string;
}

interface IGetOperationsSuccess {
  type: typeof TaxonomyActionTypeNames.GET_OPERATIONS_SUCCESS;
  taxonomyOperations: TaxonomyOperations[];
  fetchStatus: string;
}
interface IGetOperationsError {
  type: typeof TaxonomyActionTypeNames.GET_OPERATIONS_ERROR;
  fetchStatus: string;
}

interface IGetOperationsSuccess {
  type: typeof TaxonomyActionTypeNames.GET_OPERATIONS_SUCCESS;
  taxonomyOperations: TaxonomyOperations[];
  fetchStatus: string;
}
interface IGetOperationsError {
  type: typeof TaxonomyActionTypeNames.GET_OPERATIONS_ERROR;
  fetchStatus: string;
}

interface IGetAssetsSuccess {
  type: typeof TaxonomyActionTypeNames.FETCH_ASSETS_SUCCESS;
  taxonomyAssets: TaxonomyAssetInfoAdmin[];
}
interface IGetAssetsError {
  type: typeof TaxonomyActionTypeNames.FETCH_ASSETS_ERROR;
  fetchStatus: string;
}

interface IgetAssetsManufacturerModelsSuccess {
  type: typeof TaxonomyActionTypeNames.GET_ASSETS_MANUFACTURER_MODELS_SUCCESS;
  taxonomyAssetsManufacturerModel: TaxonomyAssetManufacturer[];
}
interface IgetAssetsManufacturerModelsError {
  type: typeof TaxonomyActionTypeNames.GET_ASSETS_MANUFACTURER_MODELS_ERROR;
  fetchStatus: string;
}

interface IPostNewAssetSuccess {
  type: typeof TaxonomyActionTypeNames.POST_NEW_ASSET_SUCCESS;
  taxonomyAddAssetInfo: TaxonomyAssetInfoAdmin[];
  turbineSelected?: string | number;
}
interface IPostNewAssetError {
  type: typeof TaxonomyActionTypeNames.POST_NEW_ASSET_ERROR;
  fetchStatus: string;
}

interface IPutAssetSuccess {
  type: typeof TaxonomyActionTypeNames.PUT_ASSET_SUCCESS;
  fetchStatus: string;
  taxonomyAddAssetInfo: ModifyAsset;
}
interface IPutAssetError {
  type: typeof TaxonomyActionTypeNames.PUT_ASSET_ERROR;
  fetchStatus: string;
}

interface IDeleteAssetSuccess {
  type: typeof TaxonomyActionTypeNames.DELETE_ASSET_SUCCESS;
  fetchStatus: string;
  assetKey: IassetKeyUpdate[];
}

interface IGetBearingPartsSuccess {
  type: typeof TaxonomyActionTypeNames.GET_BEARING_POSITIONS_SUCCESS;
  bearingPositions: string[];
}
interface IGetBearingPartsError {
  type: typeof TaxonomyActionTypeNames.GET_BEARING_POSITIONS_ERROR;
  fetchStatus: string;
}

interface IGetBearingsSuccess {
  type: typeof TaxonomyActionTypeNames.GET_BEARING_SUCCESS;
  taxonomyAssets: TaxonomyAssetNameBearings[];
}

interface IPostBearingsSuccess {
  type: typeof TaxonomyActionTypeNames.POST_BEARINGS_SUCCESS;
  taxonomyAddAssetInfo: TaxonomyBearingInfoAdmin[];
}
interface IPostBearingsError {
  type: typeof TaxonomyActionTypeNames.POST_BEARINGS_ERROR;
  fetchStatus: string;
}
interface IPutBearingsSuccess {
  type: typeof TaxonomyActionTypeNames.PUT_BEARINGS_SUCCESS;
  taxonomyAddAssetInfo: TaxonomyBearingInfoAdmin;
}
interface IPutBearingsError {
  type: typeof TaxonomyActionTypeNames.PUT_BEARINGS_ERROR;
  fetchStatus: string;
}

interface IDeleteBearingSuccess {
  type: typeof TaxonomyActionTypeNames.DELETE_BEARING_SUCCESS;
  fetchStatus: string;
  assetPartKey: string;
}

interface IPutTaxonomySuccess {
  type: typeof TaxonomyActionTypeNames.PUT_TURBINE_SUCCESS;
  taxonomy: TaxonomySystemInfoAdmin[];
  fetchStatus: string;
}

interface IGetUploadTaxonomySuccess {
  type: typeof TaxonomyActionTypeNames.GET_UPLOAD_TAXONOMY_SUCCESS;
  taxonomyUpload: ITaxonomyUpload[];
  fetchStatus: string;
}

interface IGetUploadTaxonomyError {
  type: typeof TaxonomyActionTypeNames.GET_UPLOAD_TAXONOMY_ERROR;
  fetchStatus: string;
}

export type TaxonomyActionTypes =
  | IGetTaxonomySuccess
  | IGetTaxonomyError
  | IDeleteWindFarmSuccess
  | IDeleteWindFarmByIdSuccess
  | IDeleteWindFarmError
  | IDeleteTurbineError
  | IDeleteTurbineSuccess
  | IGetIndustryTaxonomyCustomerSuccess
  | IGetIndustryTaxonomyCustomerError
  | IGetBrandTaxonomyCustomerSuccess
  | IGetBrandTaxonomyCustomerError
  | IPostTaxonomyCustomerSuccess
  | IPostTaxonomyCustomerError
  | IPutTaxonomyCustomerSuccess
  | IGetCountriesSuccess
  | IGetCountriesError
  | IModifyTaxonomyCustomerSuccess
  | IModifyTaxonomyCustomerError
  | IGetOperationsSuccess
  | IGetOperationsError
  | IGetAssetsSuccess
  | IGetAssetsError
  | IgetAssetsManufacturerModelsSuccess
  | IgetAssetsManufacturerModelsError
  | IPostNewAssetSuccess
  | IPostNewAssetError
  | IPutAssetSuccess
  | IPutAssetError
  | IGetBearingPartsSuccess
  | IGetBearingPartsError
  | IGetBearingsSuccess
  | IPostBearingsSuccess
  | IPostBearingsError
  | IPutBearingsSuccess
  | IPutBearingsError
  | IDeleteBearingSuccess
  | IGetIndustryTaxonomyCustomerPostSuccess
  | IPutTaxonomySuccess
  | IDeleteAssetSuccess
  | IGetUploadTaxonomySuccess
  | IGetUploadTaxonomyError;
